export interface EmployeeTraining {
  employeeID: string;
  hrRef: number;
  firstName: string;
  lastName: string;
  fullName: string;
  last4SSN: string;
  jobClass: string;
  shift: number;
  absorbUserId: string | null;
  dispatchStatus: string;
  vpJobID: string;
  vpCompanyID: number;
  trainingEnrollmentId: string;
  trainingId: string;
  signedOn: Date;
  signatureFileId: string | null;
  /** When this signature went out in a training record (#35650); null = not yet submitted. */
  submittedOn?: Date | string | null;
}
